import styled from "styled-components";

export const AuditContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  margin-bottom: 25px;
  gap: 8px;

  & .title {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
  & .description {
    font-size: 16px;
    color: #000;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0;
  margin-bottom: 25px;
  gap: 8px;

    & div[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const AuditContent = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  width: 100%;
  max-width: 1400px;
  height: 100%;
`;

export const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  table {
    width: 100%;
  }

  /* Action column */
  table thead th:nth-child(1) {
    width: 150px;
  }

  /* Detail column - widest */
  table thead th:nth-child(2) {
    width: 400px;
  }

  /* Modified by column */
  table thead th:nth-child(3) {
    width: 200px;
  }

  /* Timestamp column */
  table thead th:nth-child(4) {
    width: 200px;
  }
`; 